import React from 'react';
import { Link } from 'react-router-dom';

const PaymentFeePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment & Fee Policy</h1>
            <Link
              to="/legal"
              className="text-blue-600 hover:text-blue-500 font-medium"
            >
              ← Back to Legal Center
            </Link>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Platform Fees</h2>
            <p className="text-gray-700 mb-6">
              Vesta charges a 10% platform fee on all completed transactions. This fee covers payment 
              processing, customer support, and platform maintenance. Fees are automatically deducted 
              from seller payouts.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Payout Schedule</h2>
            <p className="text-gray-700 mb-6">
              Payouts are processed weekly on Tuesdays for all orders completed the previous week. 
              Payouts are sent via direct deposit to the seller's registered bank account. Minimum 
              payout amount is $25.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Deposit Requirements</h2>
            <p className="text-gray-700 mb-6">
              For custom orders and catering services, sellers may require deposits of up to 50% of 
              the total order value. Deposits are non-refundable unless the seller fails to deliver 
              as agreed.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Chargeback Policy</h2>
            <p className="text-gray-700 mb-6">
              In the event of a chargeback, Vesta will investigate the claim and work with both parties 
              to resolve the dispute. Sellers may be required to provide evidence of order fulfillment. 
              Unresolved chargebacks may result in account suspension.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Payment Methods</h2>
            <p className="text-gray-700 mb-6">
              Vesta accepts major credit cards, debit cards, and digital wallets. All payments are 
              processed securely through our payment partners. Cash payments are not supported for 
              platform orders.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Tax Responsibilities</h2>
            <p className="text-gray-700 mb-6">
              Sellers are responsible for collecting and remitting applicable sales taxes. Vesta provides 
              tax reporting tools but does not handle tax collection or remittance. Sellers should consult 
              with tax professionals for compliance.
            </p>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFeePolicy; 